/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from './styles';
import { PromoCodeType } from 'src/@types/PromoCode';
import PromoCodeNewEditForm from 'src/sections/@dashboard/PromoCode/PromoNewEditForm';

export const PromoModal = ({
  open,
  handleClose,
  isEdit,
  currentPromoCode,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentPromoCode: PromoCodeType | undefined;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <PromoCodeNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentPromoCode={currentPromoCode}
        />
      </StyledModalBox>
    </Modal>
  );
};
